import { render, staticRenderFns } from "./UpdateEmployeeForm.vue?vue&type=template&id=7a72c764&"
import script from "./UpdateEmployeeForm.vue?vue&type=script&lang=ts&"
export * from "./UpdateEmployeeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports